var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-form',_vm._b({ref:"form",on:{"reset":_vm.submitRefresh},model:{value:(_vm.slCustomer),callback:function ($$v) {_vm.slCustomer=$$v},expression:"slCustomer"}},'r-form',_vm.formProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }